import { useEffect, useRef } from "react";
import { useSearchParams } from "react-router-dom";

import { createDraft } from "@RequestFormV2/api/draftApi";
import { useRequestFormMode } from "@RequestFormV2/context/requestFormMode";
import { useRequestFormDraftId } from "@RequestFormV2/hooks/useRequestFormDraftId";
import { buildCreateDraftPayload } from "@RequestFormV2/utils/buildCreateDraftPayload";
import errorToast from "helpers/errorToast";

export function useCreateSystemDraftOnLocationSelect(selectedLocation: string | undefined) {
  const mode = useRequestFormMode();
  const [searchParams, setSearchParams] = useSearchParams();
  const draftId = useRequestFormDraftId();
  const createRequestLocationRef = useRef<string | null>(null);

  useEffect(() => {
    if (mode === "quick" || !selectedLocation || draftId) {
      return;
    }

    const locationAtRequestStart = selectedLocation;
    createRequestLocationRef.current = locationAtRequestStart;

    createDraft(buildCreateDraftPayload(locationAtRequestStart), mode)
      .then((res) => {
        if (createRequestLocationRef.current !== locationAtRequestStart) {
          return;
        }

        searchParams.set("draft_id", res.draft_reference_number);
        setSearchParams(searchParams);
      })
      .catch((err) => {
        if (createRequestLocationRef.current !== locationAtRequestStart) {
          return;
        }

        errorToast(err);
      });
  }, [draftId, mode, searchParams, selectedLocation, setSearchParams]);
}
